import React from "react";

/**
 * Real Results icon — a 5-point star that "shoots" in from far off the upper
 * right, zooms across, and lands with an impact squash-bounce, then STOPS
 * (one-shot per hover, unlike the looping sander/sprayer). The motion trail
 * (`.bdrv2-ico-star-trail`) streaks in behind it. Once the big star lands, four
 * small filled stars (`.bdrv2-ico-star-spark-1..4`) — stacked hidden BEHIND the
 * big star — flourish out like drawers opening: spark-1/4 slide straight out to
 * the LEFT and RIGHT side points, and spark-2/3 slide out on an ANGLE to flank
 * the TOP point (upper-left / upper-right). They rest there and stay (the
 * animation ends with the big star flanked by four smaller ones, not a lone
 * star). The sparks are rendered BEFORE the star body so they emerge from
 * behind it. All fire on chip hover / touch (see ourDoorsV2.css). currentColor.
 */
const ServiceStarIcon = () => (
  <svg
    className="bdrv2-svc-ico bdrv2-ico-star"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* motion trail — streaks toward the upper-right (the direction it came
        from) as the star arrives */}
    <g className="bdrv2-ico-star-trail" strokeWidth="1.7">
      <path d="M31 15 L43 6" />
      <path d="M33.5 20 L46 13" />
    </g>

    {/* drawer stars — four filled stars, each authored centered at (24,24)
        (outer radius 5, so clearly star-shaped, not a dot). They start stacked
        hidden at center (behind the big star); once it lands they slide out:
        spark-1/4 straight to the left/right side points, spark-2/3 on an angle
        up to flank the top point (positions/timing live in ourDoorsV2.css: base
        transforms + keyframes). Drawn BEFORE the star body so they emerge from
        behind it; all four rest clear of the big star. */}
    <g fill="currentColor" stroke="none">
      <path className="bdrv2-ico-star-spark bdrv2-ico-star-spark-1" d="M24 19 L25.18 22.38 L28.76 22.45 L25.9 24.62 L26.94 28.05 L24 26 L21.06 28.05 L22.1 24.62 L19.24 22.45 L22.82 22.38 Z" />
      <path className="bdrv2-ico-star-spark bdrv2-ico-star-spark-2" d="M24 19 L25.18 22.38 L28.76 22.45 L25.9 24.62 L26.94 28.05 L24 26 L21.06 28.05 L22.1 24.62 L19.24 22.45 L22.82 22.38 Z" />
      <path className="bdrv2-ico-star-spark bdrv2-ico-star-spark-3" d="M24 19 L25.18 22.38 L28.76 22.45 L25.9 24.62 L26.94 28.05 L24 26 L21.06 28.05 L22.1 24.62 L19.24 22.45 L22.82 22.38 Z" />
      <path className="bdrv2-ico-star-spark bdrv2-ico-star-spark-4" d="M24 19 L25.18 22.38 L28.76 22.45 L25.9 24.62 L26.94 28.05 L24 26 L21.06 28.05 L22.1 24.62 L19.24 22.45 L22.82 22.38 Z" />
    </g>

    {/* the big star (shoots in from far off-frame, then stops) — centered at
        (24,24), outer radius 12. Rendered LAST so the drawer stars emerge from
        behind it. */}
    <path
      className="bdrv2-ico-star-body"
      d="M24 12 L26.94 19.95 L35.41 20.29 L28.76 25.55 L31.05 33.71 L24 29 L16.95 33.71 L19.24 25.55 L12.59 20.29 L21.06 19.95 Z"
    />
  </svg>
);

export default ServiceStarIcon;
